import { Component, OnDestroy } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormGroupDirective,
  Validators,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { AuthService, SnackbarService } from '@/shared/services';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
  standalone: false,
})
export class RegisterComponent implements OnDestroy {
  private subscription: Subscription = new Subscription();
  // show password input
  public hide = true;
  public errorMessage: string = 'Something went wrong';
  public showError: boolean = false;
  public accessSelected: string = '';
  public env = environment;

  // login form group
  public registerForm = new FormGroup({
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
    password_confirm: new FormControl('', Validators.required),
    first_name: new FormControl('', Validators.required),
    last_name: new FormControl('', Validators.required),
    auth_code: new FormControl('', Validators.required),
  });

  constructor(
    private auth: AuthService,
    private snackbarService: SnackbarService,
    private router: Router,
  ) {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  submit(form: FormGroupDirective) {
    const { password, password_confirm } = this.registerForm.value;

    if (password !== password_confirm) {
      this.snackbarService.open('Password does not match', 'error', 'Ok');
      return;
    }

    const formData = {
      ...form.value,
      login_attempts_remain: 3,
    };
    delete formData.password_confirm;

    this.subscription.add(
      this.auth.register(formData).subscribe({
        next: (_) => {
          this.registerForm.reset();
          form.resetForm();
          const snackbarRef = this.snackbarService.open(
            'Account successfully created',
            'success',
            'Login',
          );
          snackbarRef.onAction().subscribe(() => {
            this.router.navigate(['/login']);
          });
        },
        error: ({ error }) => {
          this.snackbarService.open(error.message, 'error', 'Ok');
        },
      }),
    );
  }
}
